import React from "react";
import ReactDOM from "react-dom";
import AnalyticsPage from "../components/AnalyticsPage";
import { displayAdhesionBlock } from "./display-adhesion-block";
import { displayConsumptionsBlock } from "./display-consumptions-block";

export async function renderAnalyticsPage() {
  await ReactDOM.render(
    <AnalyticsPage />,
    document.getElementById("page-container")
  );
  displayAdhesionBlock();
  // displayConsumptionsBlock({});
}

export function displayAnalyticsPage() {
  renderAnalyticsPage();
}
